import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowRightRotate,
  faArrowUpFromBracket,
  faBarsStaggered,
  faBattery,
  faChevronLeft,
  faChevronRight,
  faLock,
  faSignal,
  faWifi,
} from '@fortawesome/free-solid-svg-icons'
import { faClone, faBookmark } from '@fortawesome/free-regular-svg-icons'
import { formatDate } from 'date-fns'

export const browsers = {
  safariDesktop: {
    top: (
      <div className='bg-base-200 flex justify-between h-8 items-stretch'>
        <div className='flex gap-2 items-stretch px-4 py-2'>
          {['gray', 'gray', 'gray'].map((color, i) => (
            <div
              key={i}
              style={{ aspectRatio: 1 }}
              className='rounded-full w-auto flex-1 bg-base-300'
            />
          ))}
        </div>
        <div className='grow px-12 py-1.5 flex items-stretch justify-center'>
          <div className='rounded min-w-3xl bg-white' />
        </div>
      </div>
    ),
    bottom: undefined,
  },
  safariIphone: {
    top: (
      <div className='bg-base-50 flex justify-between px-8 pt-5 pb-4 items-center'>
        <div className='font-semibold'>{formatDate(new Date(), 'h:mm')}</div>
        <div className='flex gap-2 items-stretch'>
          <FontAwesomeIcon icon={faSignal} />
          <FontAwesomeIcon icon={faWifi} />
          <FontAwesomeIcon icon={faBattery} />
        </div>
      </div>
    ),
    bottom: (
      <div className='bg-base-50 flex flex-col py-4 gap-4 items-stretch'>
        <div className='flex px-8'>
          <div className='flex grow p-3 gap-2 text-lg text-base-400 items-stretch bg-white border border-gray-200 rounded-xl shadow-lg justify-between'>
            <FontAwesomeIcon icon={faBarsStaggered} />
            <div className='flex gap-2 items-stretch'>
              <FontAwesomeIcon icon={faLock} className='text-sm self-center' />{' '}
              <div className='bg-base-200 w-32 rounded' />
            </div>
            <FontAwesomeIcon icon={faArrowRightRotate} />
          </div>
        </div>
        <div className='flex px-8 py-2 text-xl items-center text-blue-400 justify-around gap-8'>
          <FontAwesomeIcon icon={faChevronLeft} />
          <FontAwesomeIcon icon={faChevronRight} />
          <FontAwesomeIcon icon={faArrowUpFromBracket} />
          <FontAwesomeIcon icon={faBookmark} />
          <FontAwesomeIcon
            icon={faClone}
            className='stroke-current fill-none'
          />
        </div>
      </div>
    ),
  },
} as const
